module.exports = __webpack_public_path__ + "static/media/ic_materiels.09f91262.svg";